module.exports = __webpack_public_path__ + "static/media/coffee-roaster.3626adae.jpg";